<template>
  <div tabindex="0" class="filters__categories">
    <h6 tabindex="0" :aria-label="'Filter by' + categoryTitle">
      {{ categoryTitle }}:
    </h6>
    <div class="filters__categories-filters-wrapper">
      <div
        class="filters__categories-filter-wrapper"
        v-for="filter in filters"
        :key="filter.id"
      >
        <FilterButton
          :categoryTitle="categoryTitle"
          :id="filter.ID"
          :name="filter.Name"
          :removeFilterFromButton="() => removeFilterFromButton(filter)"
          :selected="selectedIds(filter.ID)"
          :selectedFilters="selectedFilters"
          :updateFilterFromButton="() => updateFilterFromButton(filter)"
        ></FilterButton>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FilterButton from "./FilterButton.vue";

export default Vue.component("FilterCategories", {
  props: {
    categoryTitle: String,
    filters: Array,
    removeFilterFromButton: Function,
    updateFilterFromButton: Function,
    selectedFilters: Array,
  },
  components: {
    FilterButton,
  },
  methods: {
    selectedIds: function(buttonID) {
      let isSelected = false;
      if (this.selectedFilters.indexOf(buttonID) != -1) {
        isSelected = true;
      }
      return isSelected;
    },
  },
});
</script>
